import React, { Component,useEffect, useState, useRef } from "react";
import axios from "axios";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Pagination from "../Pagination/Paginations";
import EntriesSelector from "../Pagination/EntriesSelector";
import useSortData from "../Pagination/SortData";
import { Link } from "react-router-dom";



const HrListLeaves = () => {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [cnt, setCnt] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [approving, setApproving] = useState(false);
  const approvingRef = useRef(false);

    const [checkedItems, setCheckedItems] = useState({});
   const { sortConfig, sortData, handleSort } = useSortData();

  // Load HR Leave List
  useEffect(() => {
    axios
      .get(API_BASE_URL + "/hr_leave_list", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      })
      .then((res) =>{
				setData(res.data);
				const defaultChecked = {};
  res.data.forEach(item => {
    if (item.dept_status == 2 &&
      item.hrs_status == 1) {
    defaultChecked[item.leave_id] = true;
      }
  });
  setCheckedItems(defaultChecked);
  }) 
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])

  // SEARCH FILTER
  const filteredItems = data.filter((item) =>
    `${item.employee_id} ${item.employee_name} ${item.department_name} ${item.duration} ${item.applied_on} ${item.reason} ${item.type_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  // const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);


  const sortedItems = sortData(filteredItems, checkedItems);
	const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);


   const clearInput = () => {
	setSearchTerm("");
  };


  const handleApproveSelected = async () => {
  const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[id]);

  //  alert(selectedIds.length);

  if (selectedIds.length === 0) {
    // toast.warn("No leaves selected for approval");
	toast.error("No leaves selected for approval", {
						toastId: "no-leaves-selected",
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",

					});
    return;
  }

  // block repeat clicks while an approval request is already running
  if (approvingRef.current) return;
  approvingRef.current = true;
  setApproving(true);

//   alert(JSON.stringify(selectedIds, null, 2));

  try {
    const token = localStorage.getItem("authToken");
    const response = await axios.post(
      `${API_BASE_URL}/hr_approve_leaves`,
      { leave_id: selectedIds },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (response.status == 200) {
					toast.success(response.data.message, {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
	
					});

					const timeout = setTimeout(() => {
				window.location.href = "Hr-leave";
				// window.location.reload(); // Reload the current page
			}, 3000); // Refresh after 5 seconds
	
					// setTimeout(() => {
					// 	history.push("Dept-leaves");
					// }, 1000);
	
				}

  } catch (err) {
    console.error(err);
    toast.error("Failed to approve selected leaves");
    approvingRef.current = false;
    setApproving(false);
  }
};



useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(API_BASE_URL + "/getLeaveListcnt", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        },
      });
      // console.log(response.data);
      
      setCnt(response.data);
      // console.log("Exit Procedures Count:", cnt.exitProceduresCount);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);





const columns = [
  { label: "Action", key: "action_sort_hr", sortable: true },
	{ label: "Employee Id", key: "employee_id", sortable: true },
	{ label: "Employee", key: "employee_name", sortable: true },
	{ label: "Department", key: "department_name", sortable: true },
  	{ label: "Leave Type", key: "type_name", sortable: true },
  { label: "Request Duration", key: "duration", sortable: true },
  { label: "Applied On", key: "applied_on", sortable: true },
  { label: "Reason", key: "reason", sortable: true },
  { label: "Attachment File", key: "attachement_file", sortable: false },
  { label: "Incharge", key: "incharge_status", sortable: true },
  { label: "HOD", key: "hod_status", sortable: true },
  { label: "HR", key: "hr_status", sortable: true },

];

  return (
    <>
      <ToastContainer />

      <div className="section-body mt-3">
        <div className="container-fluid">

          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
          <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600, whiteSpace: "nowrap" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
              <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
            </svg>
            Manage Leaves
          </h3>
              {/* <h3 className="card-title" style={{ color: "#e96827" }}>
                Leave List
              </h3> */}

<div className="card-header d-flex justify-content-end align-items-center w-100">

  {/* RIGHT SIDE */}
 <div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
</div>
            </div>

            {/* TABLE */}
            <div className="card-body">
              <div className="table-responsive sticky-table-wrap">
                <table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
                  <thead>
                    <tr>
                      <th
  onClick={() => handleSort("checkbox")}
  style={{
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap"
  }}
>
  {cnt?.listcount > 0 && (
    <input
      type="checkbox"
      checked={
        Object.values(checkedItems).length > 0 &&
        Object.values(checkedItems).every(Boolean)
      }
      onClick={(e) => e.stopPropagation()} // ⛔ prevent sort on click
      onChange={(e) => {
        const newChecked = {};
        data.forEach(item => {
          newChecked[item.leave_id] = e.target.checked;
        });
        setCheckedItems(newChecked);
      }}
    />
  )}

  {/* SORT ICON */}
  <span style={{ marginLeft: "6px", fontSize: "12px" }}>
    {sortConfig.key === "checkbox"
      ? sortConfig.direction === "asc"
        ? "▲"
        : "▼"
      : "⇅"}
  </span>
</th>

                      {/* <th>Action</th> */}
                      {columns.map((col) => (
  <th
    key={col.key}
    onClick={col.sortable ? () => handleSort(col.key) : undefined}
    style={{
      cursor: col.sortable ? "pointer" : "default",
      userSelect: "none",
      whiteSpace: "nowrap"
    }}
  >
    {col.label}

    {/* SORT ICONS */}
    {col.sortable && (
      <span style={{ marginLeft: "4px", fontSize: "12px" }}>
        {sortConfig.key === col.key
          ? sortConfig.direction === "asc"
            ? "▲"
            : "▼"
          : "⇅"}
      </span>
    )}
  </th>
))}

                    </tr>
                  </thead>

                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, index) => (
                        <tr key={index}>

                          <td>
 {(row.dept_status == 2 &&
                              row.hrs_status == 1 ) && (
  <input
    type="checkbox"
    checked={checkedItems[row.leave_id] || false}
    onChange={(e) =>
      setCheckedItems({
        ...checkedItems,
        [row.leave_id]: e.target.checked,
      })
    }
  />
   )}
</td>

                          {/* ACTION BUTTON */}
                          <td>
                            {(row.dept_status == 2 &&
                             row.hrs_status == 1) && (
                              <Link to={`/hr-leave-details?id=${row.leave_id}`}>
                                <i className="fe fe-maximize" />
                              </Link>
                            )}
                          </td>

                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department_name}</td>
                          <td>{row.type_name}</td>
                          <td>{row.duration}</td>
                          <td>{row.applied_on}</td>
                          <td>{row.reason}</td>
                          <td className="text-center">
                            {row.attachement_file ? (
                              <a
                                href={row.attachement_file}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="View Attachment"
                              >
                                <i className="fa fa-file-pdf-o" style={{ fontSize: "18px", color: "#dc3545" }} />
                              </a>
                            ) : (
                              <span>-</span>
                            )}
                          </td>

                          {/* HTML parsed statuses */}
                          <td>{ReactHtmlParser(row.incharge_status)}</td>
                          <td>{ReactHtmlParser(row.hod_status)}</td>
                          <td>{ReactHtmlParser(row.hr_status)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* PAGINATION */}
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />

              <div className="mt-3 text-end">
  <button
    className="btn btn-primary"
     onClick={handleApproveSelected}
     disabled={approving}
  >
    {approving ? "Approving..." : "Approve Leave"}
  </button>
</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HrListLeaves;
